import {environment} from '../../../../environments/environment';

export class ApplicationUtility {
  application_img_path = environment.application_img_path;

  static replaceImageUrl(url_base: string): string {
    const application_img_path = environment.application_img_path;
    if (url_base != null) {
      return url_base.replace("http://olas.heslb.go.tz", application_img_path);
    } else return null;
  }
}
